"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getHeadline(resultCode) {
    switch (resultCode) {
        case 'YX': // goal achieved, no mq
            return 'goalAchievedHeader'; // Congratulations!
        case 'NX': // did not achieve goal, no mq
            return 'goalMissedHeader'; // Sorry...
        case 'YY': // goal achieved, met mq
            return 'goalAchievedHeader'; // Congratulations!
        case 'YN': // goal achieved, missed mq
            return 'goalMissedHeader'; // Sorry...
        case 'NY': // goal unachieved, met mq
        case 'NN': // goal unachieved, missed mq
            return 'goalMissedHeader'; // Sorry...
        default:
            return '';
    }
}
exports.getHeadline = getHeadline;
function getSubHeadline(resultCode) {
    switch (resultCode) {
        case 'YX': // goal achieved, no mq
            return 'goalAchievedSubhead'; // You earned ${totalPoints} ${mediaLabel}.
        case 'NX': // did not achieve goal, no mq
            return 'goalMissedSubhead'; // You did not achieve your goal.
        case 'YY': // goal achieved, met mq
            return 'goalAchievedSubhead'; // You earned ${totalPoints} ${mediaLabel}.
        case 'YN': // goal achieved, missed mq
            return 'mqMissedSubhead'; // You achieved your goal, but missed the minimum qualifier.
        case 'NY': // goal unachieved, met mq
        case 'NN': // goal unachieved, missed mq
            return 'goalMissedSubhead'; // You did not achieve your goal.
        default:
            return '';
    }
}
exports.getSubHeadline = getSubHeadline;
function getMessage(resultCode) {
    switch (resultCode) {
        case 'YX': // goal achieved, no mq
            return 'objectiveAchievedMessage'; // Way to go, you achieved your goal.
        case 'YY': // goal achieved, met mq
            return 'objectiveAndMQAchievedMessage'; // Way to go, you achieved your goal and met your minimum qualifier.
        case 'NX': // goal unachieved, no mq
        case 'YN': // goal achieved, missed mq
        case 'NN': // goal unachieved, missed mq
        case 'NY': // goal unachieved, met mq
        default:
            return '';
    }
}
exports.getMessage = getMessage;
//# sourceMappingURL=objectives-codes.js.map